<table class="styled-table">
  <thead>
    <tr>
      <th>descriptor</th>
      <th>descriptor_category</th>
      <th>numeric_value</th>
      <th>string_value</th>
    </tr>
  </thead>
  <tbody *ngIf="descriptorDataListObs$ | async as descriptorDataList">
    <tr *ngFor="let descriptorDataItem of descriptorDataList">
      <td>
        <app-descriptor-item
          [id]="descriptorDataItem.descriptor_id"
        ></app-descriptor-item>
      </td>
      <td>
        <app-descriptor-categoria-item
          [id]="descriptorDataItem.descriptor_category_id"
        ></app-descriptor-categoria-item>
      </td>
      <td>{{ descriptorDataItem.numeric_value }}</td>
      <td>{{ descriptorDataItem.string_value }}</td>
    </tr>
  </tbody>
</table>
